export const normalize = (s = "") => {
  return s === null
    ? ""
    : s
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "")
        .toLowerCase();
};

export function normalizeVi(s: string): string {
  return s
    .toLowerCase()
    .normalize("NFD") // tách dấu
    .replace(/[\u0300-\u036f]/g, "") // bỏ dấu tổ hợp
    .replace(/đ/g, "d") // đ -> d
    .replace(/[^a-z0-9\s]+/g, " ") // punctuation -> space
    .replace(/\s+/g, " ") // gộp space
    .trim();
}
